// extracted by mini-css-extract-plugin
export default {"infoContainer":"TipValueWithLabel_infoContainer__mLuZs","label":"TipValueWithLabel_label__TsklZ","value":"TipValueWithLabel_value__8lWLI"};